import Link from 'next/link'
import styled from 'styled-components'

export const Wrapper = styled.div`
  overflow: hidden;
`
export const OverflowContainer = styled.div`
  display: flex;
  overflow-x: scroll;
  margin: 0 auto;
  padding: 0 24px; /* so the last tile can breath */

  & > a {
    flex-shrink: 0;
  }

  & > a:not(:last-child) {
    margin-right: 24px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  @media (max-width: 768px) {
    padding: 0 25px;
  }
`
export const Tile = styled(Link)`
  color: var(--brand-secondary);
  text-decoration: none;
  width: 100%;
  display: block;
`
export const ExperienceImage = styled.div<{ image: string }>`
  background-image: ${({ image }) => `url(${image})`};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 310px;
  border-radius: 20px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    height: 160px;
  }
`
